<!-- 全部面试 -->
<template>
  <div class="view-box">
    <div class="view-list">
      <!-- 导航栏 -->
      <van-nav-bar
        title="全部面试"
        fixed
        placeholder
        z-index="10"
        @click-left="goBack"
      >
        <template #left>
          <img src="@/assets/img/position/back.png" class="back" />
        </template>
      </van-nav-bar>
      <!-- 标签切换 -->
      <van-tabs v-model="activeName" @click="onClick">
        <van-tab title="待面试" name="a">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              :immediate-check="false"
            >
              <div
                class="view-item"
                @click="navDetails([item.job_apply_id, item.job_id], 0)"
                v-for="(item, index) in list"
                :key="index"
              >
                <img :src="item.company_logo" class="logos" />
                <div class="view-right">
                  <div class="view-top">
                    <span class="view-name">{{ item.company_name }}</span>
                    <span class="view-name">{{ timeList[index][1] }}</span>
                  </div>
                  <div class="view-top">
                    <span class="view-time"
                      >{{ item.job_name }} ·
                      {{
                        item.min_salary == item.max_salary
                          ? item.min_salary
                          : `${item.min_salary}-${item.max_salary}`
                      }}</span
                    >
                    <span class="view-time">{{ timeList[index][0] }}</span>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="已结束" name="b">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              :immediate-check="false"
            >
              <div
                class="view-item"
                @click="navDetails(item.job_id, 1)"
                v-for="(item, index) in list"
                :key="index"
              >
                <img :src="item.company_logo" class="logos" />
                <div class="view-right">
                  <div class="view-top">
                    <span class="view-name">{{ item.company_name }}</span>
                    <span class="view-name">{{
                      item.interview_status == 2
                        ? "面试通过"
                        : item.interview_status == 3
                        ? "不合格"
                        : "拒绝面试"
                    }}</span>
                  </div>
                  <div class="view-top">
                    <span class="view-time"
                      >{{ item.job_name }} ·
                      {{
                        item.salary_type == 1
                          ? "面议"
                          : item.min_salary == item.max_salary
                          ? item.max_salary
                          : `${item.min_salary}-${item.max_salary}`
                      }}</span
                    >
                    <span class="view-time">{{ timeList[index][0] }}</span>
                  </div>
                  <div class="reasons" v-show="item.interview_status == 3">
                    <span>结果反馈:</span>
                    <span>{{
                      item.interview_reason == ""
                        ? "公司还没有反馈意见哦~"
                        : item.interview_reason
                    }}</span>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { getInterviewList } from "@/api/apiData";
import { Toast } from "vant";
export default {
  inject: ["Token", "getWechatApi"],
  components: {},
  data() {
    return {
      activeName: "a", //默认展示
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      totalPages: 1,
      offset: 10,
      timeList: [],
    };
  },
  computed: {},
  methods: {
    // tab点击
    onClick(val) {
      var that = this;
      that.page = 0;
      that.totalPages = 1;
      that.list = [];
      that.loading = false;
      that.finished = false;
      that.timeList = [];
      that.getList();
    },
    //  返回上一页
    goBack() {
      this.$router.back();
    },
    navDetails(id, val) {
      const that = this;
      if (val == 0) {
        that.$router.push({
          path: "/interview/viewDetails",
          query: {
            id: id,
          },
        });
      } else {
        that.$router.push({
          path: "/position/positionDetails",
          query: {
            id: id,
          },
        });
      }
    },
    // 上拉加载
    onLoad() {
      this.getList();
    },
    // 下拉刷新
    onRefresh() {
      var that = this;
      that.page = 0;
      that.totalPages = 1;
      that.list = [];
      that.getList();
      that.loading = false;
      that.finished = false;
      setTimeout(() => {
        that.refreshing = false;
      }, 2000);
    },
    // 获取面试列表
    getList() {
      var that = this;
      let { page, totalPages, offset, list, activeName, timeList } = that;
      if (activeName == "a") {
        // 面试列表
        var obj = {
          page: page + 1,
          offset: offset,
          interview_status: 1,
        };
      } else {
        // 已结束
        var obj = {
          page: page + 1,
          offset: offset,
          interview_status: "2,3,4",
        };
      }
      if (totalPages > page) {
        getInterviewList(obj).then((res) => {
          //(res);
          if (res.code == 1) {
            that.loading = true;
            res.data.list.forEach((item) => {
              var list = item.interview_time.split(" ");
              timeList.push(list);
            });
            that.timeList = timeList;
            that.list = list.concat(res.data.list);
            that.totalPages = Math.ceil(Number(res.data.total) / offset);
            that.page = page + 1;
            if (res.data.list.length == 0) {
              setTimeout(() => {
                that.loading = false;
                that.finished = true;
              }, 2000);
              return false;
            }
            if (that.list.length > list.length) {
              setTimeout(() => {
                that.loading = false;
              }, 2000);
            }
          } else {
            Toast(res.msg);
            setTimeout(() => {
              that.$router.back();
            }, 2000);
          }
        });
      } else {
        that.loading = false;
        that.finished = true;
      }
    },
  },
  created() {
  
  },
  mounted() {
    this.Token();
    this.getList();
  },
};
</script>
<style lang='less' scoped>
/deep/.van-nav-bar__placeholder {
  height: 0.6rem !important;
}
/deep/.van-tabs__nav--line {
  border-bottom: 0.01rem solid #ebedf0;
  padding-bottom: 0;
  .van-tab {
    font-size: 0.3rem;
    font-weight: 600;
    line-height: 0.45rem;
    color: rgba(51, 51, 51, 1);
  }
  .van-tab--active {
    color: #ff4343;
  }
  .van-tabs__line {
    bottom: 0;
    width: 0.5rem !important;
    background: #ff4343;
  }
}
/deep/[class*="van-hairline"]::after {
  border: none;
}
.logos {
  width: 0.84rem;
  height: 0.84rem;
}
.view-item {
  padding: 0.3rem 0.4rem;
  font-size: 0.28rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.01rem solid rgba(178, 178, 178, 0.1);
  .view-right {
    width: 84%;
    .view-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span:first-child {
        width: 60%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .view-name {
        font-size: 0.28rem;
        font-weight: bold;
        line-height: 0.4rem;
        color: rgba(51, 51, 51, 1);
      }
      .view-time {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.4rem;
        color: rgba(128, 128, 128, 1);
      }
    }
    .reasons {
      margin-top: 0.15rem;
      font-size: 0.26rem;
      font-weight: 600;
      span:nth-child(2) {
        line-height: 1.5;
      }
    }
  }
}
</style>